import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../../commonComponents/translate';
import IndividualIcon from '../icon/IndividualIcon';
import CompanyIcon from '../icon/CompanyIcon';
import { LEGAL_TYPE, LEGAL_TYPES } from '../propTypes/legalProp';

function LegalInfoTabButton(props) {
  const { t, onClick, type, activeTab } = props;
  const isIndividual = type === LEGAL_TYPE.INDIVIDUAL;
  return (
    <button className="legalTabBtn" type="button" onClick={onClick}>
      <div className={`tab-wrapper ${activeTab ? 'active' : ''}`}>
        {isIndividual ? <IndividualIcon /> : <CompanyIcon />}
        {isIndividual ? (
          <span>{t('businessType.individual')}</span>
        ) : (
          <span>{t('company')}</span>
        )}
      </div>
    </button>
  );
}

LegalInfoTabButton.propTypes = {
  t: PropTypes.func.isRequired,
  type: PropTypes.oneOf(LEGAL_TYPES).isRequired,
  onClick: PropTypes.func.isRequired,
  activeTab: PropTypes.bool.isRequired,
};

export default translate(LegalInfoTabButton);
